export var timelinePeriods = [
    {
        id: 1,
        label: 'Технологии',
        startYear: 1980,
        endYear: 1986,
        events: [
            {
                year: 1980,
                text: 'Sinclair Research выводит на рынок ZX80, делая домашние компьютеры заметно доступнее.',
            },
            {
                year: 1982,
                text: 'ZX Spectrum быстро становится культовой платформой для игр и домашнего программирования.',
            },
            {
                year: 1983,
                text: 'Motorola демонстрирует DynaTAC 8000X, один из первых символов мобильной связи нового поколения.',
            },
            {
                year: 1984,
                text: 'Macintosh популяризирует графический интерфейс и меняет визуальный язык персональных компьютеров.',
            },
            {
                year: 1985,
                text: 'Windows 1.0 закладывает основу для массового распространения оконных операционных систем.',
            },
            {
                year: 1986,
                text: 'IBM PC Convertible показывает, как вычислительная техника начинает становиться по-настоящему переносной.',
            },
        ],
    },
    {
        id: 2,
        label: 'Кино',
        startYear: 1987,
        endYear: 1991,
        events: [
            {
                year: 1987,
                text: '«Робокоп» Пола Верховена превращает научную фантастику в острую сатиру о корпорациях и городе будущего.',
            },
            {
                year: 1988,
                text: '«Кто подставил кролика Роджера» впечатляет тем, как соединяет живое действие и анимацию в одном кадре.',
            },
            {
                year: 1989,
                text: '«Назад в будущее 2» превращает фантазию о будущем в один из главных поп-культурных образов конца 80-х.',
            },
            {
                year: 1990,
                text: '«Крепкий орешек 2» закрепляет моду на масштабные и напряжённые голливудские боевики.',
            },
            {
                year: 1991,
                text: '«Семейка Аддамс» возвращает интерес к готической комедии и эксцентричным семейным историям.',
            },
            {
                year: 1991,
                text: '«Терминатор 2» Джеймса Кэмерона задаёт новый уровень для визуальных эффектов и зрелищного экшена.',
            },
        ],
    },
    {
        id: 3,
        label: 'Литература',
        startYear: 1992,
        endYear: 1997,
        events: [
            {
                year: 1992,
                text: 'Литературный рынок входит в новую эпоху, где издатели и авторы ищут собственные модели выживания.',
            },
            {
                year: 1993,
                text: 'Независимые журналы и альманахи становятся пространством для появления новых авторских голосов.',
            },
            {
                year: 1994,
                text: 'Небольшие издательства начинают формировать собственные каталоги и узнаваемые книжные серии.',
            },
            {
                year: 1995,
                text: 'Книжные ярмарки и фестивали превращаются в важную площадку встречи читателей, критиков и издателей.',
            },
            {
                year: 1996,
                text: 'Переводная литература всё сильнее влияет на читательский вкус и расширяет культурный горизонт публики.',
            },
            {
                year: 1997,
                text: 'К концу периода массовая проза и переводные издания становятся устойчивой частью книжного рынка.',
            },
        ],
    },
    {
        id: 4,
        label: 'Театр',
        startYear: 1999,
        endYear: 2004,
        events: [
            {
                year: 1999,
                text: 'Театр всё чаще обращается к документальным сюжетам и разговору о современной социальной реальности.',
            },
            {
                year: 2000,
                text: 'Молодые труппы выходят на независимые площадки и пробуют новые форматы общения со зрителем.',
            },
            {
                year: 2001,
                text: 'Новые режиссёрские школы приносят на сцену более смелый и экспериментальный визуальный язык.',
            },
            {
                year: 2002,
                text: 'Фестивали открывают зрителю международные постановки и усиливают обмен театральными идеями.',
            },
            {
                year: 2003,
                text: 'Сценография становится лаконичнее, а пространство сцены начинает работать как самостоятельный образ.',
            },
            {
                year: 2004,
                text: 'К середине 2000-х театральные коллаборации и фестивальные проекты становятся важной частью отрасли.',
            },
        ],
    },
    {
        id: 5,
        label: 'Искусство',
        startYear: 2005,
        endYear: 2014,
        events: [
            {
                year: 2005,
                text: 'Галереи начинают активнее соединять цифровое искусство, городскую среду и публичные пространства.',
            },
            {
                year: 2006,
                text: 'Видеоарт и интерактивные работы занимают всё более заметное место в крупных выставочных проектах.',
            },
            {
                year: 2007,
                text: 'Художники всё чаще создают site-specific проекты, тесно связанные с конкретным местом и контекстом.',
            },
            {
                year: 2008,
                text: 'Мультимедийные инсталляции становятся одной из ведущих форм художественного высказывания.',
            },
            {
                year: 2010,
                text: 'Кураторы всё чаще строят экспозиции вокруг маршрута, эмоций и вовлечения самого зрителя.',
            },
            {
                year: 2011,
                text: 'Онлайн-платформы помогают художникам быстрее выходить на международную аудиторию и новые рынки.',
            },
        ],
    },
    {
        id: 6,
        label: 'Наука',
        startYear: 2015,
        endYear: 2022,
        events: [
            {
                year: 2015,
                text: 'Фиксация гравитационных волн подтверждает одну из ключевых идей общей теории относительности.',
            },
            {
                year: 2016,
                text: 'Новые наблюдения телескопов дают больше данных о далёких галактиках и потенциально пригодных для жизни мирах.',
            },
            {
                year: 2017,
                text: 'Генетические исследования ускоряют развитие персонализированной медицины и точной диагностики.',
            },
            {
                year: 2018,
                text: 'Запуск Falcon Heavy делает частную космонавтику одной из самых обсуждаемых тем года.',
            },
            {
                year: 2019,
                text: 'Первое изображение чёрной дыры становится историческим моментом для астрофизики и визуализации космоса.',
            },
            {
                year: 2021,
                text: 'Запуск телескопа James Webb открывает новый этап в наблюдении ранней Вселенной и далёких звёздных систем.',
            },
        ],
    },
];
